/* legend.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._3iDTPbvbI6%7Bdisplay%3Ainline-block%7D%0A._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._1kk5Tkmb2E%7Bfont-weight%3Avar(--ds-font-weight-bold%2C653)%7D%0A._0rIjyk1Y8M%7Bmargin-block-end%3Avar(--ds-space-050%2C4px)%7D%0A._43nrzTPgdg%7Bmargin-block-start%3Avar(--ds-space-0%2C0)%7D");





import { type ReactNode } from 'react';
const fieldsetLabelStyles = null;
export interface LegendProps {
  children: ReactNode;
}
/**
 * __Legend__
 *
 * A Legend represents a caption for a fieldset in a user interface.
 */
export const Legend: ({
  children
}: LegendProps) => JSX.Element = ({
  children
}: LegendProps) => {
  return <legend className={ax(["_2sNsIg7NXe _3iDTPbvbI6 _1UtDYzZpcK _1kk5Tkmb2E _0rIjyk1Y8M _43nrzTPgdg"])}>{children}</legend>;
};